/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Table_FromInputs */

const en_us2_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const pt_br2_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir de`)
};

const es_419_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde`)
};

const pt_pt2_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A partir de`)
};

const fr_fr2_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À partir de`)
};

const de_de2_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ab`)
};

const it_it2_exercise_personal_strength_table_from = /** @type {(inputs: Exercise_Personal_Strength_Table_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Exercise_Personal_Strength_Table_FromInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_table_from = /** @type {((inputs?: Exercise_Personal_Strength_Table_FromInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Table_FromInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_table_from(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_table_from(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_table_from(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_table_from(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_table_from(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_table_from(inputs)
	return en_us2_exercise_personal_strength_table_from(inputs)
});
export { exercise_personal_strength_table_from as "exercise-personal.strength_table_from" }